import { MenuId, MenuRegistry } from "../../actions/common/actions";
import { Command, CommandsRegistry, ICommandCanExecuteReturnValue } from "../../commands/common/commands";
import { ContextMenuContext, isContextMenuContext } from "../../contextview/common/context";
import { ServicesAccessor } from "../../instantiation/common/instantiation";
import { isPropertyLike } from "./properties";



export class RefreshPropertyValueContextKeyCommand extends Command {

    static readonly ID = 'property.refreshPropertyValueContextKey';

    constructor() {
        super(RefreshPropertyValueContextKeyCommand.ID, 'Refresh Property Value');
    }

    canExecute(args: ContextMenuContext): ICommandCanExecuteReturnValue {
        if (isContextMenuContext(args)) {
            return {
                canExecute: true,
            }
        }
        return {
            canExecute: false,
        }
    }

    execute(_accessor: ServicesAccessor, args: unknown) {
        if (isContextMenuContext(args)) {
            const props = args.targets.filter(t => isPropertyLike(t));
            for (const prop of props) {
                prop.notifyChanged();
            }
        }
    }
}


CommandsRegistry.registerCommand(new RefreshPropertyValueContextKeyCommand());

MenuRegistry.appendMenuItem(MenuId.PropertyContext, {
    command: {
        id: RefreshPropertyValueContextKeyCommand.ID,
        title: 'Refresh Value',
        icon: {
            id: "refresh"
        },
    },
    group: 'property',
    order: -100,
})